module.exports = __webpack_public_path__ + "static/media/35-2.b1703851.mp3";